import { FC, useState } from "react";
import SimpleSlider from "./simple-slider";
import SimpleDocPreviewer from "./docs/simple-doc-previewer";
import { PiTrash } from "react-icons/pi";
import FlexBox from "./flex-box";
import LoadingBox from "./loading-box";
import ErrorBox from "./error-box";

interface SimpleDocumentSliderProps {
  documents: File[];
  isRenderAgain?: boolean;
  className?: string;
  label?: string;
  isShowBorder?: boolean;
  isLoading?: boolean;
  isError?: string;
  onRemove?: (index: number) => void;
}

const SimpleDocumentSlider: FC<SimpleDocumentSliderProps> = ({
  documents,
  isRenderAgain,
  className,
  label,
  isShowBorder = true,
  isLoading = false,
  isError,
  onRemove,
}) => {
  const [slideIndex, setSlideIndex] = useState<number>(0);

  const child = isError ? (
    <ErrorBox message={isError} />
  ) : documents.length > 0 ? (
    <SimpleSlider
      isAutoPlay
      isShowNavigation
      isRenderAgain={isRenderAgain}
      className={isShowBorder && "border rounded"}
      onSlideChange={setSlideIndex}
    >
      {documents.map((doc) => (
        <SimpleDocPreviewer
          doc={doc}
          isShowRemoveButton={false}
          key={doc?.name}
        />
      ))}
    </SimpleSlider>
  ) : (
    <small>No files to preview</small>
  );

  return (
    <div className={className}>
      <FlexBox>
        {label && (
          <label className="text-muted">
            <b>{label}</b>
          </label>
        )}
        {onRemove && documents?.length > 0 && (
          <PiTrash
            className="cursor-pointer hover-danger"
            onClick={() => onRemove(slideIndex ?? 0)}
          />
        )}
      </FlexBox>
      <div>{isLoading ? <LoadingBox /> : <>{child}</>}</div>
    </div>
  );
};

export default SimpleDocumentSlider;
